import { useRef, useEffect } from "react";
import styled from "styled-components";
import React from "react";
import { Grid } from "@material-ui/core";
import { TextView } from "../../components"; // Ensure this component exists and is correctly imported
import { ASSETS } from "../../utils/config";

import {
  Container,
  IconWrapper,
  SegmentButton,
  SegmentText,
  LabelWrapper,
  LabelText,
  StyledSwitch,
  MenuContainer,
  MenuItem,
  moveArrow,
  AnimatedDiv,
  IndicatorDiv,
} from "./style";
import CustomSwitch from "../../components/CustomSwitch";

const SegmentActions = ({
  value,
  handleSwitch,
  handleSegmentButton,
  handleRotation,
  selectedArc,
  isSideMenuActive,
  isOpen,
  handleClick,
  isShowLeftOrRight,
  wheelData,
}) => {
  const getRightSpacing = () => {
    // Use CSS calc() and viewport units with fallbacks for better zoom responsiveness
    const baseSpacing = selectedArc
      ? isSideMenuActive
        ? "min(22vw, 300px)"
        : "min(26vw, 350px)"
      : "min(22vw, 300px)";

    // For extreme zoom cases, fall back to pixel values
    if (window.innerWidth < 1000) {
      return selectedArc ? (isSideMenuActive ? 18 : 22) : 18;
    }

    return baseSpacing;
  };

  const menuRef = useRef();

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      handleClick();
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <Container>
      <Grid container spacing={2} alignItems="center" justifyContent="center">
        {wheelData?.length != 0 && (
          <Grid item>
            <IconWrapper>
              <img
                src={ASSETS.segmentEditor.ReloadIcon}
                width={16}
                height={15.71}
                alt="Reload Image"
                onClick={() => handleClick()}
              />

              {isOpen && (
                <MenuContainer right={getRightSpacing()} ref={menuRef}>
                  <MenuItem onClick={() => handleRotation("next")}>
                    <img
                      src={ASSETS.segmentEditor.ClockWise}
                      width={14}
                      height={14}
                      alt="clock wise"
                    />
                    Clockwise
                  </MenuItem>
                  <MenuItem onClick={() => handleRotation("prev")}>
                    <img
                      src={ASSETS.segmentEditor.AntiClockWise}
                      width={14}
                      height={14}
                      alt="clock wise"
                    />
                    Counter-Clockwise
                  </MenuItem>
                </MenuContainer>
              )}
            </IconWrapper>
          </Grid>
        )}
        <Grid item>
          <SegmentButton>
            <SegmentText onClick={handleSegmentButton}>
              <img
                src={ASSETS.plus}
                width={14}
                height={14}
                alt="plus Image"
                style={{ marginRight: "5px" }}
              />
              Segment
            </SegmentText>
          </SegmentButton>
        </Grid>
        {wheelData?.length != 0 && (
          <Grid item>
            <LabelWrapper>
              <LabelText>Show Label</LabelText>
              <CustomSwitch
                defaultChecked={true}
                value={value}
                onChange={handleSwitch}
              />
            </LabelWrapper>
          </Grid>
        )}
      </Grid>
      {/* {!isShowLeftOrRight && (
        <AnimatedDiv>
          <IndicatorDiv>
            <TextView variant="subtitle">Start Here</TextView>
          </IndicatorDiv>
        </AnimatedDiv>
      )} */}
    </Container>
  );
};

export default SegmentActions;
